/**
 * Antwort von /umbraco/md/shop/search (ShopSearchResult, camelCase).
 */

import { t } from './../common/localizer.ts';

export interface ShopItem {
    id: number;
    name: string;
    kurzzeichen: string | null;
    imageUrl: string | null;
    kaufLink: string | null;
    kostenlos: boolean;
    /** Link in den ePaper-Viewer, wenn der Artikel eine Ausgabe hat. */
    ePaperUrl: string | null;
}

export interface ShopFilterItem {
    id: string;
    label: string;
    count: number;
    checked: boolean;
}

export interface ShopFilterGroup {
    /** Name des URL-Parameters: cat0, cat1, ... */
    key: string;
    id: string;
    label: string;
    /** Ohne Auswahl setzt der Server die Sprache der Seite ein (Sprache). */
    required: boolean;
    items: ShopFilterItem[];
}

export interface ShopSearchResult {
    items: ShopItem[];
    totalCount: number;
    page: number;
    pageSize: number;
    totalPages: number;
    groups: ShopFilterGroup[];
}

/** Gewählte Kategorie-IDs pro Gruppe (Schlüssel = cat0, cat1, ...). */
export type ShopSelection = Record<string, string[]>;

/** Wörterbuch-Einträge unter "Shop"; fehlt ein Eintrag, gilt der deutsche Text. */
const FALLBACK: Record<string, string> = {
    'Shop.Search': 'Suchen',
    'Shop.SearchPlaceholder': 'Suchbegriff',
    'Shop.ResetFilter': 'Filter zurücksetzen',
    'Shop.Apply': 'Übernehmen',
    'Shop.All': 'alle',
    'Shop.None': 'keine',
    'Shop.Free': 'Kostenlos',
    'Shop.EPaper': 'ePaper ansehen',
    'Shop.Results': '{0} Treffer',
    'Shop.NoResults': 'Keine Produkte gefunden.',
    'Shop.Error': 'Die Produkte konnten nicht geladen werden.',
};

export function label(key: string, ...args: Array<string | number>): string {
    const text = t(key, ...args);
    if (!text.startsWith('#-')) {
        return text;
    }

    const fallback = FALLBACK[key] ?? key;
    return fallback.replace(/\{(\d+)}/g, (match, index) => args[Number(index)] != null ? String(args[Number(index)]) : match);
}
